/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "../Modal/index";
import "react-datepicker/dist/react-datepicker.css";
import {
  addNewMembers,
  selectMemberInfo,
  getCities,
  getTowns,
} from "../../../state/ducks/member";
import {
  clearCandidateRedirect,
  selectAuthenticate,
} from "../../../state/ducks/login";
import $ from "jquery";
import StaticModal from "../shared/StaticModal";
import ReactPixel from "react-facebook-pixel";
import AppCustomSelect from "../shared/AppCustomSelect";

function changebg() {

  var num = Math.ceil(Math.random() * 2);
  document.body.background = "assets/img/loginBackground/loginback_" + num + ".jpg";
  document.body.style.backgroundSize = "cover";

}

$(function () {
  $(".without-number").keydown(function (e) {
    if (e.ctrlKey || e.altKey) {
      e.preventDefault();
    } else {
      var key = e.keyCode;
      if (
        !(
          key == 8 ||
          key == 9 ||
          key == 32 ||
          key == 46 ||
          (key >= 35 && key <= 40) ||
          (key >= 65 && key <= 90) ||
          key == 186 ||
          (key >= 191 && key <= 222)
        )
      ) {
        e.preventDefault();
      }
    }
  });
});

function formControl(stateAd, stateSoyad, stateCity, stateTown) {

  var kvkk_check = document.getElementById("kvkk_check");
  var mesaj = document.getElementById("mesaj");
  var control = true;
  mesaj.innerHTML = "";
  var control = true;

  if (/^[a-zA-Z_ğüşıöçĞÜŞİÖÇ ]+$/.test(stateAd)) {

  } else {

    mesaj.innerHTML += "<br/>Lütfen geçerli bir Ad giriniz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }

  //Soyad alanı
  if (/^[a-zA-Z_ğüşıöçĞÜŞİÖÇ ]+$/.test(stateSoyad)) {

  } else {

    mesaj.innerHTML += "<br/>Lütfen geçerli bir Soyad giriniz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }

  if (stateCity != null && stateCity !== "") {

  } else {

    mesaj.innerHTML += "<br/>İl bilgisi boş bırakılamaz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }

  if (stateTown != null && stateTown !== "") {

  } else {

    mesaj.innerHTML += "<br/>İlçe bilgisi boş bırakılamaz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }

  if (kvkk_check.checked === false) {
    mesaj.innerHTML +=
      "<br/>Kişisel verilerin korunması aydınlatma ve bilgilendirmesi onayı boş bırakılamaz.";
    $("#hata_mesaji").modal("show");
    control = false;
  }
  return control;
}
class NewMember extends Component {
  state = {
    corporate: false,
    uyeNo: "",
    ad: "",
    soyad: "",
    token: "",
    reklamIzni: false,
    cities: [],
    towns: [],
    cityId: "",
    townId: "",
    countDate: Date.now() + 300000,
  };

  componentDidMount() {

    this.props.clearRedirect();
    $(".react-datepicker-wrapper").addClass("form-control");
    changebg();
    ReactPixel.init("210664537388285");
    ReactPixel.pageView();
    getCities().then((cities) => {
      this.setState({
        cities: cities,
      });
    });
    this.createCaptchaToken();
  }

  componentDidUpdate() {
    if (this.props.member?.successFirst) {
      this.props.history.push("/yeniuyelikkod");
    }
  }

  addNewMember = (event) => {
    event.preventDefault();

    if (this.state.countDate < Date.now() || this.props.login.newCandidate === ""
      || this.props.login.newCandidate === undefined || this.props.login.newCandidate === null) {
      this.props.history.push("/giris");
    } else {
      var control = formControl(this.state.ad, this.state.ad, this.state.cityId, this.state.townId);

      if (control) {
        const postData = {
          ad: this.state.ad,
          soyad: this.state.soyad,
          token: this.state.token,
          reklamIzni: this.state.reklamIzni,
          sehirId: this.state.cityId,
          ilceId: this.state.townId,
          telefonNo: this.props.login.newCandidate,
        };
        this.props.addNewMember(postData);
      }
      this.createCaptchaToken();
    }
  };

  setReklamIzni = (e) => {
    this.setState({
      reklamIzni: e.target.checked,
    });
  };

  handleChange = (e) => {
    this.setState({
      townId: e.target.value,
    });
  };

  handleCityChange = (cityId) => {
    this.setState({
      cityId,
      townId: "",
    });
    getTowns(cityId).then((towns) => {
      this.setState({
        towns: towns,
      });
    });
  };

  createCaptchaToken() {
    var that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token: token });
        });
    });
  }

  render() {
    return (
      <>
        <div className="container-fluid">
          <Modal message={alert?.message} type={alert?.type} />
          <div className="row d-flex align-items-center justify-content-center vh-100">
            <div className="col-10 col-md-7 col-lg-6 col-xl-4 t-sifreAlani">
              <div className="row no-gutters d-flex justify-content-center px-4">
                {/* LOGO */}
                <div className="col-12 d-flex justify-content-center pb-2">
                  <i className="t-icon-smile t-loginSifreAlBaslikIcon" />
                </div>
                <div className="col-12 d-flex justify-content-center pb-3 t-loginSifreAlBaslik">
                  YENİ ÜYE KAYDI
                </div>
                {/* TC KİMLİK */}
                <div className="col-12 col-lg-10 col-xl-8 pb-1">
                  <span className="t-loginText pl-3">Ad</span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8 pb-2">
                  <div className="t-inputLogin">
                    <div>
                      <i className="t-icon-user1" />
                    </div>
                    <input
                      id="ad"
                      name="ad"
                      type="text"

                      placeholder="Adınız"
                      maxLength="30"
                      value={this.state.ad}
                      onChange={(e) => {
                        this.setState({
                          ad: e.target.value.toLocaleUpperCase(),
                        });
                      }}

                    />
                    <div />
                  </div>
                </div>
                {/* AD SOYAD */}
                <div className="col-12 col-lg-10 col-xl-8 pb-1">
                  <span className="t-loginText pl-3">Soyad</span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8 pb-2">
                  <div className="t-inputLogin">
                    <div>
                      <i className="t-icon-user1" />
                    </div>
                    <input
                      id="soyad"
                      name="soyad"
                      type="text"

                      maxLength="30"
                      placeholder="Soyadınız"
                      value={this.state.soyad}
                      onChange={(e) => {
                        this.setState({
                          soyad: e.target.value.toLocaleUpperCase(),
                        });
                      }}

                    />
                    <div />
                  </div>
                </div>
                {/* GSM */}
                <div className="col-12 col-lg-10 col-xl-8 pb-1">
                  <span className="t-loginText pl-3">İl</span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8 pb-2">
                  <div className="t-inputLogin">
                    <div>
                      <i className="t-icon-location1" />
                    </div>
                    <AppCustomSelect
                      id="cityId"
                      value={this.state.cityId}
                      placeholder="İl Seçiniz"
                      options={[
                        { value: "", label: "İl Seçiniz" },
                        ...(this.state.cities?.map((item) => ({
                          value: String(item.id),
                          label: item.adi,
                        })) || []),
                      ]}
                      onChange={this.handleCityChange}
                    />
                    <div />
                  </div>
                </div>
                {/* Doğum Tarihi */}
                <div className="col-12 col-lg-10 col-xl-8 pb-1">
                  <span className="t-loginText pl-3">İlce</span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8 pb-4">
                  <div className="t-inputLogin">
                    <div>
                      <i className="t-icon-location1" />
                    </div>
                    <AppCustomSelect
                      id="townId"
                      value={this.state.townId}
                      placeholder="İlçenizi Seçiniz"
                      options={[
                        { value: "", label: "İlçenizi Seçiniz" },
                        ...(this.state.towns?.map((item) => ({
                          value: String(item.id),
                          label: item.adi,
                        })) || []),
                      ]}
                      onChange={(nextValue) => this.setState({ townId: nextValue })}
                    />
                    <div />
                  </div>
                </div>
                {/* Kişisel Verileri Koruma*/}
                <div className="col-12 col-lg-10 col-xl-8 pb-2 t-loginText d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="kvkk_check"
                    name="kvkk_check"
                    required
                    style={{ width: "40px", height: "40px" }} />
                  <span style={{ paddingLeft: 10 }}>
                    Kişisel verilerin korunması aydınlatma ve bilgilendirmesi'ni okudum,
                    kabul ediyorum.
                  </span>
                </div>
                <div>
                </div>
                <div className="col-12 col-lg-10 col-xl-8 pb-2 t-loginText d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="reklam_check"
                    name="reklam_check"
                    onChange={this.setReklamIzni}
                    value={this.state.reklamIzni}
                    style={{ width: "50px", height: "40px" }} />
                  <span style={{ paddingLeft: 10 }}>
                    Kampanyalardan haberdar olmak için Emin Üstün Holding Şirketleri'nden ticari elektronik ileti
                    almak istiyorum.
                  </span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8 pb-2 d-flex justify-content-center">
                  <strong>
                    <a
                      href="https://www.eminevim.com/kvkk"
                      target="yeni"
                      className="t-loginLink "
                    >
                      KVKK Metni İncele
                    </a>
                  </strong>
                </div>
                {/* ara boşluk*/}
                <div className="col-12" />
                <div className="col-12 d-flex justify-content-center pt-4 px-1">
                  <button
                    className="t-loginGirisButton"
                    type="submit"
                    onClick={this.addNewMember}
                  >
                    <span className="px-2" />
                    DEVAM ET
                    <i
                      className="t-icon-arrow-right2 pl-2"
                      style={{ fontSize: "14pt" }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <StaticModal></StaticModal>
        </div>

        <div className="t-loginTradeMark">© EMİNEVİM tüm hakları saklıdır.</div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
    login: selectAuthenticate(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearRedirect: () => dispatch(clearCandidateRedirect()),
  addNewMember: (newMember) => dispatch(addNewMembers(newMember)),
  getCities: () => dispatch(getCities()),
  getTowns: () => dispatch(getTowns()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewMember);
